import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

import { Grid, Row, Col } from 'react-bootstrap';
import cx from 'classnames';

// Locale
import Loader from '../../Loader';
import { photosShow } from '../../../helpers/photosShow';
import { homebanneruploadDir } from '../../../config';

import cs from '../../commonStyle.css';
import s from './HomeKindofTrip.css';

function HomeKindofTrip({ loading, staticInfo }) {
    const path = photosShow(homebanneruploadDir);

    if (loading) {
        return <Loader type={"text"} />;
    }

    return (
        <div className={s.container}>
            <div className={s.homeFind}>
                <div className={cx(cs.commonTitleText, cs.paddingBottom6, cs.textAlignCenter, cs.fontWeightBold)}>
                    {staticInfo?.carTripTitle1}
                </div>
                <Row>
                    {[1, 2].map(index => {
                        const imageKey = `carTripImage${index}`;
                        const titleKey = `carTripTitle${index + 1}`;
                        const contentKey = `carTripContent${index + 1}`;

                        return (
                            <Col
                                key={index}
                                lg={6}
                                md={6}
                                sm={6}
                                xs={12}
                                className={index === 1 ? cx(s.paddingTopMobile) : ''}
                            >
                                <div className={s.bgSection}>
                                    <div
                                        className={s.homeFindBg}
                                        style={{ backgroundImage: `url(${path}${staticInfo?.[imageKey]})` }}
                                    />
                                    <div className={s.bgInnerSection}>
                                        <div className={s.bgCss}>
                                            <div className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.paddingBottom3, s.borderBottom, 'borderBottomKindRTL')}>
                                                {staticInfo?.[titleKey]}
                                            </div>
                                            <div className={s.homeParaInner}>
                                                {staticInfo?.[contentKey]}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </div>
    );
}

HomeKindofTrip.propTypes = {
    title: PropTypes.string,
    loading: PropTypes.bool,
    staticInfo: PropTypes.object,
};

export default withStyles(s, cs)(HomeKindofTrip);
